<div class="row no-gutters">
  <div class="col">

  </div>
<!--<div style="width: 40%" class=" col-4">-->
   <div style="width: 30%;" class="dropdown-label-group">
      <p-dropdown [options]="dashboards"
                  [(ngModel)]="selectDashboard"
                  class="dv-dropdown"
                  selectId="year"
                  id="dashboards"
                  placeholder="{{'DOC-DASHBOARD.DASHBOARDLIST' | translate}}"
                  (onChange)="choosedashboard()"

      >
      </p-dropdown>
   <label for="dashboards">{{'DOC-DASHBOARD.DASHBOARDLIST' | translate}}</label>

   </div>

     </div>
<!--</div>-->


 <div [ngSwitch]="keepdashboard" >
   <div *ngSwitchCase="null" class="mt-2">
     <app-dashboard-document></app-dashboard-document>
   </div>


<!--        <div *ngSwitchCase="2" >-->
<!--          <div style="margin-top: -30px">-->
<!--            <app-dashboard-sms></app-dashboard-sms>-->

<!--          </div>-->
<!--        </div>-->
        <div *ngSwitchCase="3" >
          <div style="margin-top: -30px">
            <app-email-dashboard></app-email-dashboard>

          </div>
        </div>
</div>


<!--<div class="header">-->
<!--  <div class="row">-->
<!--    <div class="col-md">-->
<!--      <h3>{{'DASHBOARD.TITLE' | translate}}</h3>-->
<!--    </div>-->
    <!--<div class="col-6 col-md-2">-->
      <!--<div class="dropdown-label-group">-->
        <!--<p-dropdown-->
          <!--class="dv-dropdown"-->
          <!--selectId="company"-->
          <!--[options]="company"-->
          <!--[(ngModel)]="selectedCompany"-->
          <!--[autoDisplayFirst]="false"-->
          <!--placeholder="บริษัท"-->
        <!--&gt;-->
        <!--</p-dropdown>-->
        <!--<label for="company">บริษัท</label>-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="col-6 col-md-2">-->
      <!--<div class="dropdown-label-group">-->
        <!--<p-dropdown-->
          <!--class="dv-dropdown"-->
          <!--selectId="companyBusiness"-->
          <!--[options]="homeproGroup"-->
          <!--[(ngModel)]="selectedHomeproGroup"-->
          <!--[autoDisplayFirst]="false"-->
          <!--placeholder="ประเภทธุรกิจ"-->
        <!--&gt;-->
        <!--</p-dropdown>-->
        <!--<label for="companyBusiness">ประเภทธุรกิจ</label>-->
      <!--</div>-->
    <!--</div>-->
<!--    <div>-->
      <!--<div class="dropdown-label-group">-->
<!--        <p-dropdown-->
<!--          class="dv-dropdown"-->
<!--          selectId="year"-->
<!--          [options]="yearList"-->
<!--          [(ngModel)]="selectedYear"-->
<!--          [autoDisplayFirst]="false"-->
<!--          placeholder="ปี"-->
<!--          (onChange)="loadMonthlyData()"-->
<!--        >-->
<!--        </p-dropdown>-->
        <!--<label for="year">ปี</label>-->
      <!--</div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!--<div class="box-parent scrollable" style="height: calc(100vh - 2.25rem - 150px);">-->
<!--  <canvas id="signing-counter-bar-chart">{{ charts_signing_counter_bar_stacked }}</canvas>-->
<!--</div>-->



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-list/dashboard-list.component.html